import { render, staticRenderFns } from "./ServiceSettingPage.vue?vue&type=template&id=4428f986&"
import script from "./ServiceSettingPage.vue?vue&type=script&lang=js&"
export * from "./ServiceSettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports